<template>
    <div class="login-wrapper">
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form login-container" auto-complete="on">
            <!-- <div class="title">{{ $t('login.title')}}</div> -->
            <div class="title">能源管理云平台</div>
            <el-form-item prop="username" :error="errors.userLoginError">
                <el-input v-model="loginForm.username" class="login-input" :placeholder="$t('login.username')" name="username" type="text" auto-complete="on">
                    <span class="svg-container" slot="prepend">
                        <i class="el-icon-user"></i>
                    </span>
                </el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input type="password"  class="login-input" v-model="loginForm.password" :placeholder="$t('login.password')" name="password" auto-complete="on" @keyup.native.enter="handleLogin">
                    <span class="svg-container" slot="prepend">
                    <i class="el-icon-lock"></i>
                    </span>
                </el-input>
            </el-form-item>
            <el-form-item prop="value">
                <el-row :gutter="5">
                    <el-col :span="15">
                        <el-input type="text" class="login-input" v-model="loginForm.value" name="value" placeholder="请输入验证码" auto-complete="on" @keyup.native.enter="handleLogin">
                            <span class="svg-container" slot="prepend">
                            <i class="el-icon-key"></i>
                            </span>
                        </el-input>
                    </el-col>
                    <el-col :span="9" :loading="imageloading" style="text-align:center;font-size:0;line-height:0;">
                        <el-tooltip class="item" effect="dark" content="点击刷新" placement="right">
                            <img :src="imageUrl" alt="点击刷新" style="max-width:100%;height: 40px;cursor:pointer;background-color:#FFF;" @click="getCaptcha">
                        </el-tooltip>
                    </el-col>
                </el-row>
            </el-form-item>
            <div class="btn-container" style="margin-bottom:20px;">
                <el-button style="width:100%;background-color:rgba(64, 110, 173, 1);border:0;" v-loading="loading" type="primary" @click.native.prevent="handleLogin">{{ $t('login.loginbBtn') }}</el-button>
            </div>
        </el-form>
        <the-footer></the-footer>
    </div>

</template>

<script>
import TheFooter from "@/components/TheFooter";
import { mapGetters } from "vuex"; 
import Service from '@/api/Service'
import Storage from '@/utils/storage'
import config from '@/config'

const jsSHA = require("jssha");
export default {
    name: "Login",
    data() {
        return {
            loginForm: {
                username: "",
                password: "",
                value: '',
                captchaId: '',
            },
            imageUrl: "",
            imageloading: false,
            loginNum: 0,    //  登录次数
            loginRules: {
                username: [
                    {
                        required: true,
                        trigger: "blur",
                        message: this.$t("login.unInputUserError")
                    }
                ],
                password: [
                    {
                        required: true,
                        trigger: "blur",
                        message: this.$t("login.unInputPwdError")
                    }
                ],
                value: [
                    {
                        required: true,
                        trigger: "blur",
                        message: "请输入验证码"
                    }
                ]
            },
            errors: {
                userLoginError: ''
            },
            loading: false
        };
    },
    computed: {
         
    },
    mounted() {
        // 清空信息
        this.$store.dispatch("ClearUser");
    },
    created() {
        this.getCaptcha()
        localStorage.clear();
    },
    components: {
        TheFooter
    },
    methods: {
        async getCaptcha() {
            this.imageloading = true
            let res = await Service.getCaptcha()
            if(res) {
                this.imageUrl = config.DEFAULT_FILE_PATH +"/ucenter/v2"+ res.imageUrl;
                //this.imageUrl = "/ucenter/v2"+ res.imageUrl;
                this.loginForm.captchaId = res.captchaId
                this.imageloading = false
            }
        },
        handleLogin() {
            this.$refs.loginForm.validate(valid => {
                if (valid) {
					//密码加密方式
                    let shaObj = new jsSHA("SHA-512", "TEXT");
                    shaObj.update(this.loginForm.password);
                    // 登录参数
                    let parms = {};
                    parms.username = this.loginForm.username;
                    parms.captchaId = this.loginForm.captchaId;
                    parms.value = this.loginForm.value;
                    parms.password = shaObj.getHash("HEX");
                    
                    if(this.loginNum >= 4) {
                        // 登录失败次数
                        this.checkLoginNum();
                        return
                    }
                    
                    this.loading = true;
                    Service.login(parms).then(res=>{
                        this.loading = false;
                        if(res) {
                            Storage.set('token', {token:res})
                            
                            this.getUserInfo();
                        }else{
                            this.loginNum++;
							this.getCaptcha()
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        async getUserInfo() {
            let res = await Service.userInfo();
            if(res) {
                const usertype = res.usertype // Usertype:1/2/3/4   四类账号
                if(usertype === 1) {
                    // this.$router.push("/projectlist");
                    this.$router.push('/admin');
                }else{
                    this.$router.push("/projectlist");
                }
            }
        },
        checkLoginNum() {
            let Time
            clearTimeout(Time);

            this.$notify({
                title: '警告',
                message: '操作频繁，请等待15s后再试！',
                type: 'warning'
            });
            
            Time = setTimeout(() => {
                this.loginNum = 0;
            }, 15000);
        }
    }
};
</script>

<style lang="less" scoped>
.login-wrapper{
    width: 100vw;
    height: 100vh;
    background: url(/resources/homeimge/bg-img.png) no-repeat;
    background-size: 100% 100%;
    position: relative;
    &::after{
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: -1;
        background:linear-gradient(180deg,rgba(13,32,92,1) 0%,rgba(18,47,97,1) 23%,rgba(24,51,96,1) 41%,rgba(21,46,89,1) 67%,rgba(10,31,70,1) 83%,rgba(10,22,59,1) 100%);
        opacity:0.84;
    }
}
.login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    // -webkit-border-radius: 5px;
    // border-radius: 5px;
    // -moz-border-radius: 5px;
    // background-clip: padding-box;
    // padding: 35px 35px 15px 35px;
    // background: #fff;
    // border: 1px solid #eaeaea;
    // box-shadow: 0 0 25px #cac6c6;
    position: absolute;
    left: 50%;
    top: 150px;
    width:358px;
    margin-left: -179px;
    .title{
        text-align: center;
        font-size:36px;
        font-family:PingFangSC-Semibold;
        font-weight:600;
        color:rgba(248,203,107,1);
        line-height:50px;
        margin-bottom: 60px;
    }
    .login-input{
        position: relative;
        z-index: 99;
        &::after{
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: -1;
            background-color: rgba(236, 244, 255, .09);
            // opacity: .8;
            border-radius: 4px;
        }
        &::-webkit-input-placeholder { /* WebKit browsers */
            color:rgba(204,204,204,1);
            font-size: 14px;
        }

        &::-moz-placeholder { /* Mozilla Firefox 19+ */
            color:rgba(204,204,204,1);
            font-size: 14px;
        }

        &:-ms-input-placeholder { /* Internet Explorer 10+ */
            color:rgba(204,204,204,1);
            font-size: 14px;
        }
    }
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>